import React, { useEffect, useState } from "react";
import styles from "./searchDropDown.module.scss";
import Xicon from "../../assets/images/header/icons/X.svg";
import HeaderProductCategories from "../../layouts/Header/headerServices/HeaderServices";
import ReactLoading from "react-loading"; // Loading komponentini import edirik
import { Link } from "react-router-dom"; // Link import edilir

interface HeaderDropdownProps {
  onMouseEnter: () => void;
  onMouseLeave: () => void;
  translations?: any;
  searchData: any[];
  loading: boolean;
  searchValue: string;
  onItemClick?: () => void;
}

// const SearchDropDown: React.FC<HeaderDropdownProps> = ({
//   onMouseEnter,
//   onMouseLeave,
//   translations,
// }) => {
//   const [searchValue, setSearchValue] = useState("");
//   const [searchData, setSearchData] = useState<any[]>([]);
//   const [loading, setLoading] = useState(false); // Loading state

//   const fetchData = async (keyword: string) => {
//     setLoading(true);
//     try {
//       const response = await HeaderProductCategories.getSearchProduct(keyword);
//       if (
//         response.data &&
//         response.data.products &&
//         response.data.products.length > 0
//       ) {
//         setSearchData(response.data.products);
//         console.log("Məhsullar:", response.data.products);
//       } else {
//         console.log("Məhsullar tapılmadı");
//         setSearchData([]);
//       }
//     } catch (error) {
//       console.error("Xəta baş verdi:", error);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const searchHandler = (searchValue: string) => {
//     setSearchValue(searchValue);
//     if (searchValue === "") {
//       setSearchData([]);
//     } else {
//       fetchData(searchValue);
//     }
//   };
//   useEffect(() => {
//     setSearchData([]);
//   }, []);

//   return (
//     // <div
//     //   className={styles.dropdownContainer}
//     //   onMouseEnter={onMouseEnter}
//     //   onMouseLeave={onMouseLeave}
//     // >
//     //   <div className={styles.dropDownContent}>
//     //     {/* <div className={styles.searchInputContent}>
//     //       <input
//     //         placeholder={translations?.search}
//     //         className={styles.searchInput}
//     //         value={searchValue}
//     //         onChange={(e) => searchHandler(e.target.value)}
//     //       />
//     //       {searchValue && (
//     //         <img
//     //           className={styles.xicons}
//     //           src={Xicon}
//     //           alt="X icon"
//     //           onClick={() => {
//     //             setSearchValue("");
//     //             setSearchData([]);
//     //           }}
//     //           style={{ cursor: "pointer" }}
//     //         />
//     //       )}
//     //     </div> */}
//     //     <div className={styles.endSearch}>
//     //       <div className={styles.endSearchTitleContend}></div>
//     //       <div className={styles.endSearchContendTexts}>
//     //         {loading ? (
//     //           <div className={styles.loadingContainer}>
//     //             <ReactLoading
//     //               type="spin"
//     //               color="#3983f0"
//     //               height={50}
//     //               width={50}
//     //             />
//     //           </div>
//     //         ) : searchValue && searchData.length === 0 ? (
//     //           <p className={styles.endSearchContendText}>
//     //             {translations?.no_result}
//     //           </p>
//     //         ) : (
//     //           searchData.length > 0 &&
//     //           searchData.map((product, index) => (
//     //             <Link
//     //               to={`/productDetail/${product.id}`}
//     //               key={index}
//     //               className={styles.endSearchContendText}
//     //               style={{ textDecoration: "none", color: "inherit" }}
//     //             >
//     //               <div className={styles.searchCover}>
//     //                 <img src={product.cover_image} alt="" />
//     //                 <div className={styles.searchTextContent}>
//     //                   <div className={styles.searchTitle}>
//     //                     {product.product_name}
//     //                   </div>
//     //                   <div className={styles.searchPrice}>
//     //                     {product.price}AZN
//     //                   </div>
//     //                 </div>
//     //                 <div className={styles.searchDescription}>
//     //                   <p>
//     //                     {product.product_description?.length > 50
//     //                       ? `${product.product_description.substring(0, 50)}...`
//     //                       : product.product_description}
//     //                   </p>
//     //                 </div>
//     //               </div>
//     //             </Link>
//     //           ))
//     //         )}
//     //       </div>
//     //     </div>
//     //   </div>
//     // </div>

//   );
// };

const SearchDropDown: React.FC<HeaderDropdownProps> = ({
  onMouseEnter,
  onMouseLeave,
  translations,
  searchData,
  loading,
  searchValue,
  onItemClick,
}) => {
  
  return (
    <div
      className={styles.dropdownContainer}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
    >
      <div className={styles.dropDownContent}>
        {loading ? (
          <div className={styles.loadingContainer}>
            <ReactLoading type="spin" color="#3983f0" height={50} width={50} />
          </div>
        ) : searchData.length === 0 ? (
          /* Nəticə yoxdursa bura işləyəcək */
          <div className={styles.noResultWrapper}>
            <p className={styles.endSearchContendText} style={{ color: "#000" }}>
              {translations?.no_result || "Nəticə tapılmadı"}
            </p>
          </div>
        ) : (
          /* Nəticə varsa bura işləyəcək */
          searchData.map((product, index) => (
            <Link
              to={`/productDetail/${product.product_slug || product.id}`}
              key={product.id || index}
              className={styles.endSearchContendText}
              onClick={onItemClick}
            >
                  <div className={styles.searchCover}>
                    <img src={product.cover_image} alt={product.product_name} />
                    <div className={styles.searchTextContent}>
                      <div className={styles.searchTitle}>
                        {product.product_name}
                      </div>
                      <div className={styles.searchPrice}>{product.price} AZN</div>
                    </div>
                    <div className={styles.searchDescription}>
                      <p>
                        {product.product_description?.length > 50
                          ? `${product.product_description.substring(0, 50)}...`
                          : product.product_description}
                      </p>
                    </div>
                  </div>
                </Link>
              ))
        )}
      </div>
    </div>
  );
};

export default SearchDropDown;
